// extracted by mini-css-extract-plugin
export default {"wrapper":"RegisterForm_wrapper__LiKF+","block":"RegisterForm_block__rFIoB","form":"RegisterForm_form__IXRFd","body":"RegisterForm_body__mReAj","footer":"RegisterForm_footer__c3l6P"};